import { ContentProps } from 'app/components/Accordion';

export const FaqList: ContentProps[] = [
  {
    label: 'What is AIDA?',
    content:
      'AIDA stands for Aid Information Data Analytics and is a data services platform for professionals working in ' +
      'the aid chain, who are interested to explore, analyse and use (public) data sources in an easy to use' +
      ' application.',
  },
  {
    label: 'Who created AIDA?',
    content:
      'AIDA is an initiative by The Open Data Company B.V., a joint venture of Zimmerman B.V. ' +
      'and Data4Development B.V.',
  },
  {
    label: 'Who is it for?',
    content:
      'AIDA is for professionals in the development aid sector: Project & Policy Officers, Program Managers,' +
      " Fund Managers, Researchers, Embassy staff, Journalists. In short, anybody who has an interest in 'who' " +
      "funds 'what, where and when' and who is curious about the effect or 'impact' of the development aid.",
  },
  {
    label: 'Can my organisation make use of AIDA?',
    content:
      'Yes, on top of building data capacity within your organisation, you can make use of what is already available.' +
      ' AIDA can be used to visualise available IATI data and get insight into who is funding and implementing what' +
      ' in which country and sectors and with which partners.',
  },
  {
    label: 'How is IATI data used on AIDA?',
    content:
      '<a href="https://iatistandard.org/" target="_blank">IATI</a> is the core of the platform as it is one of the more mature aid data standards available.' +
      ' We view IATI as an important means to provide transparency on the actors on the development aid chain.' +
      ' AIDA now enables you to benchmark your own data against the data of other publishers.' +
      ' The future ambition is to combine various data sources on this platform.',
  },
];

export const ExploringList: ContentProps[] = [
  {
    label: 'The data of my organisation is not correct. How can I change it?',
    content:
      'The map and tables show the data your organisation published through IATI.' +
      ' If your organisation’s IATI publication is not fully accurate you will indeed see that reflected here.' +
      ' We can advise you on your IATI publication so your IATI publication will provide an accurate image of your' +
      ' organisation’s activities. <a href="/support#contact" target="_blank">Contact us</a>.',
  },
  {
    label: 'What does the map show?',
    content:
      'The map allows you to see how aid development is distributed across the world.' +
      ' Please keep in mind that only data that is published to IATI is reflected in this map.',
  },
  {
    label: 'How can I use the filters?',
    content:
      'Select an item in the filter menu to open a filter, in which you can select any number of items.' +
      ' Click “Apply” to see the data and visualisations applicable to the current filter selection.' +
      ' Once a filter has been selected, the other filter menus will only show filters applicable to the current' +
      ' selection. If you would like to explore the data in more depth select “More Filters” to view a detailed' +
      ' list of additional filters. A green dot next to an item in the filter menu indicates the filter is active.' +
      ' Filters can be reset completely using the reset button on the right side of the filter menu,' +
      ' or within filter windows for individual filters.',
  },
  {
    label: 'What is the data in each of the filters?',
    content:
      '<b>Country</b> <br/>The recipient country, i.e. the country that will benefit from a particular activity.' +
      '<br/><br/><b>Region</b><br/> The recipient region, i.e. the supranational geopolitical region that will benefit from' +
      ' a particular activity. <br/><br/><b>Budget</b><br/>The value of the activity’s budget for each financial quarter or' +
      ' year over the lifetime of the activity.<br/><br/><b>Sectors</b><br/>The names to describe sectors within the' +
      ' OECD DAC CRS, as used within the IATI Standard. At the top of the filter window you can switch between DAC3' +
      ' and DAC5 sector codes.<br/><br/><b>Donors</b><br/>The organisation providing the money for the transaction.' +
      '<br/><br/><b>Organisations</b><br/>An organisation involved with the activity. This may be a donor, fund, agency, etc.' +
      '<br/><br/><b>Publishers</b><br/>The reporting organisation that published the information to the <a href="https://iatistandard.org/" target="_blank">IATI standard</a>. ' +
      'A reporting organisation may provide information on its own activities, as well as reporting on behalf of ' +
      'other organisations involved in the delivery of aid.<br/><br/><b>Period</b><br/>The time when the activity takes place.' +
      ' When you select specific dates in the period filter, it will show all activities with a reported start' +
      ' date within the selected time period.<br/><br/><b>Activity Status</b><br/>The current status of the activity.',
  },
  {
    label: 'How do I use the search function?',
    content:
      'Type one or more keywords into the search box. A preview of the results will be shown in the search window,' +
      ' divided into activities, countries, organisations, publishers and donors.' +
      ' Pressing enter will show the results in a table format.',
  },
  {
    label: 'What is an activity?',
    content:
      'An activity is the IATI name given to any piece of work an organisation does. ',
  },
  {
    label: 'What is an organisation?',
    content:
      'An organisation involved with the activity. This may be a donor, fund, agency, etc.',
  },
  {
    label: 'What is a publisher?',
    content:
      'The reporting organisation that published the information to the <a href="https://iatistandard.org/" target="_blank">IATI standard</a>.' +
      ' A reporting organisation may provide information on its own activities, as well as reporting on behalf' +
      ' of other organisations involved in the delivery of aid.',
  },
  {
    label: 'What is a donor?',
    content:
      'The organisation providing the money for the transaction.' +
      ' An organisation that receives money from one donor and then passes it' +
      ' on to another partner organisation is therefore both receiver and donor.',
  },
  {
    label: 'How and in what format can I download datasets?',
    content:
      'In the table view of the data, click the cloud icon in the top right corner of the table.' +
      ' This will allow you to download the current selection in CSV format.',
  },
  // {
  //   label: 'Why are not all activities shown in the sector visualization?',
  //   content:
  //     'You may have noticed that in some cases, the number of activities in the sector visualization is less than' +
  //     ' the total number of activities for a particular country or organisation. This is because it is not mandatory' +
  //     ' for publishers to report the sector for their activities. Activities that do not have a sector associated with' +
  //     ' them will not be reflected in the sector visualization.',
  // },
];

export const TechnicalList: ContentProps[] = [
  {
    label: 'Why is data missing in some parts of the platform?',
    content:
      'The AIDA platform shows data as it is published to the <a href="https://iatiregistry.org/" target="_blank">IATI Registry</a>. Publishers report their data in' +
      ' varying degrees of detail, so not all activities will contain information on all IATI elements.' +
      ' Additionally, data that contain critical IATI validation failures will not be visible in AIDA.' +
      ' If you feel your data is not listed on AIDA please <a href="/support#contact" target="_blank">contact us</a>.',
  },
  {
    label: 'When and how is data on AIDA updated?',
    content:
      'The data on AIDA is updated when a reparse is triggered manually.' +
      ' New and updated datasets are downloaded from the IATI registry and parsed to fit the datastore standard.',
  },
  {
    label: 'Which transaction types are used in the AIDA platform?',
    content:
      'The activity detail page shows incoming and outgoing transactions based on the IATI <a href="https://iatistandard.org/en/iati-standard/203/codelists/transactiontype/" target="_blank">transaction-type codelist</a>.' +
      ' Incoming transactions show data for codes 1 (incoming funds), 11 (incoming commitment),' +
      ' and 13 (incoming pledge). Outgoing transactions show data for codes 2 (outgoing commitment),' +
      ' 3 (disbursement), 4 (expenditure) and 12 (outgoing pledge).',
  },
  {
    label: 'How are exchange rates calculated?',
    content:
      'Transaction values are converted into USD in order to aggregate monetary data.' +
      ' The exchange rates are retrieved from the <a href="https://www.imf.org/en/Home" target="_blank">International Monetary Fund</a>,' +
      ' based on the <a href="https://www.imf.org/en/About/Factsheets/Sheets/2016/08/01/14/51/Special-Drawing-Right-SDR" target="_blank">Special Drawing Right</a> per currency unit.' +
      ' The exchange rates are based on monthly averages and stored in our database,' +
      ' and are updated whenever a reparse of the data happens.',
  },
  {
    label: 'Where do country descriptions come from?',
    content:
      'Country descriptions are retrieved from the first paragraph of the relevant country’s Wikipedia page.',
  },
];

export const AidaPackagesList: ContentProps[] = [
  {
    label: 'What features do I have included in my licence?',
    content:
      'The AIDA Platform allows you to choose the best licence for you and your organisation. You can choose to explore for free or unlock certain features by purchasing the standard or premium licence. To see all features included in each licence, click <a href="/plans#compare">here</a>',
  },
  {
    label:
      'Where can I get more support if I did not buy the support package together with my licence?',
    content: `If you did not purchase the support package together with your licence, you can  <a target="blank" href="mailto:info@aida.tools">contact us</a> and we can make a personalised support offer for you and your organisation.`,
  },
  {
    label: 'When can I change/ renew my licence?',
    content:
      'If you already purchased a licence, your package will be fixed for the first year. After the first year, you can choose to continue, upgrade or downgrade your licence. Together with this, you will be able to make changes on a monthly basis.',
  },
];
